@if (campaign) {
  <shared-modal [mobile]="sharedService.screenSize !== 'l'" width="640px">
    <!-- header -->
    <h2 slot="header" class="flex">
      Detalhes da campanha
      <span
        class="material-symbols-rounded cursor-pointer ml-auto"
        (click)="sharedService.closeModal(route)"
        >close</span
      >
    </h2>

    <p
      class="whitespace-pre-wrap p-4 bg-black/5 rounded-md"
      [innerHTML]="campaign.text || '' | markdown"
    ></p>
    @if (campaign.media.length) {
      <blu-media-input
        [(media)]="campaign.media"
        [readonly]="true"
      ></blu-media-input>
    }
  </shared-modal>
}
